<template>
  <h3>Kam se mnou na tábor v roce 2026?</h3>
    <p>Plánuji 2 tábory na Fryšavě.</p>

    <h5>Podzim 2026</h5>
      <p><b>7. - 13. 9. 2026</b></p>
      <br>
      <p>Týdenní tábor - základ jako vždy - přivolání, odložení, míjení psů, sebekontrola i individuálky kdy zamakáme na tom, co vás trápí. Abychom neuvařili psy ani sebe, jsou tréninky proložené vycházkami, výlety i jedním půldnem zcela bez psí účasti.</p>
      <p><a href="https://clovek-a-pes-spolu.dogres.cz/trainings/471535" target="_blank">Prohlédnout si detaily a přihlásit se můžete ZDE</a></p>
  <h3>Proběhlé tábory</h3>
  
    <h5>Jaro 2026</h5>
      <b>PLNO! - Přihlašování jen na pozici náhradníka</b><br>
      <p>v termínu <b>30. 4. - 3. 5. 2026</b></p>
      <p>Program se bude odvíjet od vašeho zájmu a počasí - předpokládám pilování přivolání, pozornosti, sebekontroly, nějaké nové triky nebo ladění známých cviků, k tomu trocha vycházek, ošetření nebo dogfitness.</p>
      <p><a href="https://clovek-a-pes-spolu.dogres.cz/trainings/465421" target="_blank">Prohlédnout si detaily a přihlásit se můžete ZDE</a></p>


    <h5>Podzim 2025</h5>
      <p><b>Kdy?</b> 2. - 5. 10. </p>
      <p><b>Kde?</b> Fryšava pod Žákovou horou - Chalupa na konci světa</p>
      
    <h5>Jaro 2025</h5>
        <p><b>Kdy?</b> Na přelomu dubna a května </p>
        <p><b>Kde?</b> na Fryšavě na úplně úžasném místě</p>
        
</template>

<script>
import { useMeta } from 'vue-meta'

export default {
  name: 'Tabory',

  setup () {
    useMeta({ title: 'Člověk a pes spolu - pořádané tábory' })
  },

}

</script>

<style lang="scss">
a {
  color: $secondary
}
</style>
